// extracted by mini-css-extract-plugin
export default {"overlay":"modalOverlay_overlay__ADc8s"};